export enum EncryptedField {
  socialSecurityNumber = 'encryptedSocialSecurityNumber',
  bankAccountNumber = 'bankAccountNumber',
  routingNumber = 'routingNumber',
  federalTaxId = 'federalTaxId',
}
